import "@story/story_assets/modules/base";
import { onDocumentReady } from "@story/story_assets/utils";
import "./smap/callbacks";

(function () {
	// *************************************************************************
	// SMap loading
	// *************************************************************************

	let loaderPromise = null;
	function load(callback) {
		if (!loaderPromise) {
			loaderPromise = new Promise(function (resolve) {
				Modules.loadScript("https://api.mapy.cz/loader.js", function () {
					Loader.async = true;
					Loader.load(null, null, function () {
						resolve();
					});
				});
			});
		}
		loaderPromise.then(callback);
	}

	// *************************************************************************
	// Initialization
	// *************************************************************************

	class MapyCz {
		constructor(element) {
			this.element = element;
			this.map = null;
			this.markerLayer = null;

			this.init();
			this.callback();
		}

		init() {
			let centerPosition = JSON.parse(this.element.getAttribute("data-smap-center"));
			let mapZoom = this.element.getAttribute("data-smap-zoom");

			let mapCenter = SMap.Coords.fromWGS84(centerPosition[1], centerPosition[0]);

			let map = new SMap(this.element, mapCenter, mapZoom);
			map.addDefaultLayer(SMap.DEF_BASE).enable();

			map.addControl(new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_ZOOM));
			map.addControl(new SMap.Control.ZoomNotification);
			map.addControl(new SMap.Control.Compass({ title: SMap._("map.move") }));
			map.addControl(new SMap.Control.Zoom(
				{
					2: SMap._("map.zooms.world"),
					5: SMap._("map.zooms.states"),
					8: SMap._("map.zooms.districts"),
					11: SMap._("map.zooms.cities"),
					14: SMap._("map.zooms.municipalities"),
					17: SMap._("map.zooms.streets"),
					20: SMap._("map.zooms.houses"),
					21: SMap._("map.zooms.birdEye")
				},
				{
					titles: [SMap._("map.zoomIn"), SMap._("map.zoomOut")]
				}
			));

			// map.addControl(new SMap.Control.Scale);
			map.addControl(new SMap.Control.Sync);

			// Place controls
			map.setPadding("right", map.getPadding("right") + 73 + 8 + 2);
			JAK.DOM.addClass(map._dom.container, "smap-defaults");

			// Set up cursor
			map.setCursor("move");

			this.map = map;
		}

		callback() {
			let callback = this.element.getAttribute("data-smap-callback");
			if (callback) {
				if (window[callback]) {
					window[callback](this);
				}
				else {
					console.error("Callback method " + callback + " not found.");
				}
			}
		}

		//
		// Add marker to map
		//
		addMarker(latitude, longitude, title, options) {
			// Create marker layer (if not exists)
			if (!this.markerLayer) {
				this.markerLayer = new SMap.Layer.Marker();
				this.map.addLayer(this.markerLayer);
				this.markerLayer.enable();
			}

			var point = SMap.Coords.fromWGS84(longitude, latitude);

			// Set up title
			options = options || {};
			if (!options.title) {
				options.title = title;
			}

			var marker = new SMap.Marker(
				point,
				false,
				options
			);

			this.markerLayer.addMarker(marker);

			return marker;
		}

	}

	// *************************************************************************
	// Connect with DOM
	// *************************************************************************

	load(function () {
		onDocumentReady(function () {
			for (let element of document.querySelectorAll("[data-smap]")) {
				new MapyCz(element);
			}
		});
	});
})();
